// R&C, real & enriched content

export const brand = {
  logoWhite: "https://customer-assets.emergentagent.com/job_polished-video-hero/artifacts/miu5httt_R%26C%20ONLINE%20LOGO%20white%20.png",
  logoDark: "https://customer-assets.emergentagent.com/job_polished-video-hero/artifacts/m9ipau5x_R%26C%20ONLINE%20LOGO.png",
  yellow: "#F5D000",
  accentSoft: "#FFE34D"
};

export const company = {
  name: "R&C",
  subtitle: "Public & Civil Engineers",
  tagline: "Civil Engineering Contractors",
  phone: "0121 326 9696",
  email: "info@randcwilliams.ltd.uk",
  hours: "Mon-Fri: 07:00 - 17:00",
  established: 1957,
  location: "Spaghetti Junction, Birmingham",
  address: "Salford Trading Estate, Birmingham B6 7BN, UK"
};

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Projects", to: "/projects" },
  { label: "Clients", to: "/clients" },
  { label: "ESG", to: "/esg" },
  { label: "Giving Back", to: "/charity" },
  { label: "News", to: "/news" },
  { label: "Contact", to: "/#contact" }
];

// --- Real R&C uploaded asset URLs ---
const A = {
  heroVideo: "https://customer-assets.emergentagent.com/job_polished-video-hero/artifacts/qhstkoi7_R%26C%20Sneaky%20peak%20into%20whats%20to%20come.mp4",
  team: "https://customer-assets.emergentagent.com/job_polished-video-hero/artifacts/1auy91dq__MG_4670.jpg",
  sparks: "https://customer-assets.emergentagent.com/job_polished-video-hero/artifacts/ddysuieu__MG_4532.jpg",
  aerial: "https://customer-assets.emergentagent.com/job_polished-video-hero/artifacts/pt6khuuc_DJI_0047.jpg",
  highway: "https://customer-assets.emergentagent.com/job_polished-video-hero/artifacts/o2yf3ckz__MG_4220.jpg",
  garden: "https://customer-assets.emergentagent.com/job_polished-video-hero/artifacts/dp8t9x75_Garden-071.jpg",
  braunstone: "https://customer-assets.emergentagent.com/job_polished-video-hero/artifacts/uoggolrs_image.png",
  droitwich: "https://customer-assets.emergentagent.com/job_polished-video-hero/artifacts/k8jrb3l2_image.png",
  cressbrook: "https://customer-assets.emergentagent.com/job_polished-video-hero/artifacts/di8t92jc_image.png"
};
export const assets = A;

export const heroSlides = [
  {
    id: 1,
    video: A.heroVideo,
    poster: A.aerial,
    eyebrow: "Public & Civil Engineers · Birmingham",
    title: "Groundbreaking Engineering.",
    titleAccent: "Built for Generations.",
    subtitle: "Over 60 years constructing the bridges, structures and steelworks that connect the UK."
  },
  {
    id: 2,
    video: "",
    poster: A.team,
    eyebrow: "Heritage · 60 Years Strong",
    title: "A Team You Can",
    titleAccent: "Build a Future On.",
    subtitle: "Three generations of craftsmen, engineers and project leaders, delivering for the Midlands since 1957."
  },
  {
    id: 3,
    video: "",
    poster: A.highway,
    eyebrow: "Bridges · Steelworks · Highways",
    title: "From £500 Repairs to",
    titleAccent: "£8M Infrastructure.",
    subtitle: "Trusted by Balfour Beatty, Kier, Tarmac and authorities across the Midlands and beyond."
  }
];

// ALL projects (used in /projects and /projects/:id)
export const projects = [
  {
    id: "braunstone-culvert",
    title: "Braunstone Culvert Replacement",
    type: "Culvert Replacement & Flood Mitigation",
    category: "Drainage",
    year: "2024",
    location: "Mossdale Meadows, Braunstone, Leicester",
    client: "Leicester City Council",
    cover: A.braunstone,
    gallery: [A.braunstone, A.aerial, A.sparks],
    overview: "R&C replaced a failing culvert crossing at Mossdale Meadows, Braunstone, improving drainage capacity and reducing future flood risk. The project involved the installation of a new precast concrete box culvert within an active watercourse.",
    challenge: "The existing structure had deteriorated and required replacement to ensure continued access and effective water management. Restricted site access, poor ground conditions, and environmental constraints added complexity to the works.",
    solution: "Working alongside the client and environmental specialists, R&C removed the existing structure and installed a new precast concrete culvert. Temporary water management measures, silt control systems, and environmental protection procedures were implemented throughout the programme.",
    outcome: "The completed structure provides improved hydraulic capacity, enhanced resilience against flooding, and a long-term infrastructure solution for the local area. The works were delivered safely and efficiently while protecting the surrounding environment.",
    facts: [
      "New precast concrete box culvert installed",
      "Flood risk reduction",
      "Environmental protection measures implemented",
      "Active watercourse works",
      "Improved long-term drainage performance"
    ]
  },
  {
    id: "droitwich-health-corridor",
    title: "Droitwich Health Corridor",
    type: "Highway Improvement & Active Travel Infrastructure",
    category: "Highways",
    year: "2024",
    location: "Droitwich, Worcestershire",
    client: "Worcestershire County Council",
    cover: A.droitwich,
    gallery: [A.droitwich, A.highway, A.aerial],
    overview: "R&C delivered key infrastructure improvements as part of the Droitwich Health Corridor Project, helping to create safer, more accessible routes for pedestrians and cyclists while enhancing connections between healthcare facilities, residential areas, and local amenities.",
    challenge: "The scheme was delivered within a busy urban environment where maintaining access for residents, businesses, and road users was essential. Careful planning was required to minimise disruption while ensuring the works progressed safely and efficiently.",
    solution: "R&C carried out a range of highway and public realm improvements, including new footways, kerbing, surfacing, drainage upgrades, and associated infrastructure works. The project was delivered in phases with appropriate traffic management and stakeholder coordination throughout.",
    outcome: "The completed scheme provides improved accessibility, safer routes for pedestrians and cyclists, and better connectivity across the local area. The project supports healthier travel choices while delivering lasting improvements to the town's infrastructure.",
    facts: [
      "Active travel infrastructure improvements",
      "New footway and kerbing works",
      "Highway surfacing upgrades",
      "Drainage improvements",
      "Improved pedestrian accessibility",
      "Enhanced cycling connectivity",
      "Urban environment delivery",
      "Reduced disruption through phased construction"
    ]
  },
  {
    id: "cressbrook-mill-bridge",
    title: "Cressbrook Mill Plastic Footbridge",
    type: "Sustainable Footbridge Installation",
    category: "Sustainable",
    year: "2023",
    location: "Cressbrook Mill, Peak District National Park",
    client: "Derbyshire County Council",
    cover: A.cressbrook,
    gallery: [A.cressbrook, A.aerial, A.team],
    overview: "R&C delivered the installation of an innovative new footbridge at Cressbrook Mill in the Peak District National Park. The project replaced a deteriorated bridge with a sustainable Fibre Reinforced Polymer (FRP) structure made using approximately 26,000 recycled plastic bottles, providing a long-term, low-maintenance solution.",
    challenge: "The existing bridge had suffered significant corrosion and was no longer suitable for long-term use. Located within a remote and environmentally sensitive area, the project required careful planning, restricted access management, and specialist lifting operations to safely install the new structure.",
    solution: "R&C designed and installed a new FRP footbridge with hardwood handrails, creating a durable and environmentally responsible crossing. The bridge was transported through narrow Peak District routes before being lifted into place using a large crane and specialist installation methods. Sustainable materials and innovative construction techniques were used throughout the project.",
    outcome: "The completed bridge reconnects important walking routes between the Monsal Trail, Cressbrook Dale, and the surrounding countryside. With an expected lifespan of 120 years and minimal maintenance requirements, the structure provides a lasting community asset while significantly reducing future environmental impact.",
    facts: [
      "Fibre Reinforced Polymer (FRP) bridge installation",
      "Approximately 26,000 recycled plastic bottles used",
      "120-year design lifespan",
      "Minimal maintenance requirements",
      "Peak District National Park location",
      "Sustainable construction materials",
      "Specialist crane lifting operation",
      "Improved access for walkers and visitors"
    ]
  },
  {
    id: "svr-bridgnorth",
    title: "Severn Valley Railway Footbridge",
    type: "Heritage Railway Infrastructure",
    category: "Heritage Railway",
    year: "2023",
    location: "Bridgnorth Station, Shropshire",
    client: "Severn Valley Railway",
    cover: A.aerial,
    gallery: [A.aerial, A.team, A.sparks],
    overview: "A heritage-sympathetic footbridge replacement at Bridgnorth Station, blending Victorian charm with modern structural standards.",
    challenge: "Working at an active heritage railway station required minimising disruption to services and preserving the station's listed Victorian character.",
    solution: "Fabrication and installation of a steel structure sympathetic to the station's architectural heritage, with phased works coordinated around the railway's operating timetable.",
    outcome: "A safe, fully compliant footbridge that preserves the visual heritage of one of the UK's most beloved heritage railways.",
    facts: ["Heritage-sympathetic design", "Listed station environment", "Active railway coordination", "Steel fabrication on site"]
  },
  {
    id: "a38-barton",
    title: "A38 Barton Turns Bridge",
    type: "Highway Bridge Refurbishment",
    category: "Highways",
    year: "2022",
    location: "Barton-under-Needwood, Staffordshire",
    client: "National Highways",
    cover: A.highway,
    gallery: [A.highway, A.aerial, A.team],
    overview: "Full structural refurbishment of a critical Staffordshire highway bridge, delivered with zero unplanned closures.",
    challenge: "A heavily trafficked A-road bridge required deep structural intervention while keeping traffic flowing.",
    solution: "Phased night works, temporary deflection structures and rapid-set concrete techniques to minimise disruption.",
    outcome: "Restored 50-year design life, zero unplanned closures, completed two weeks ahead of programme.",
    facts: ["Highways refurbishment", "Phased delivery", "Zero unplanned closures", "Ahead of programme"]
  },
  {
    id: "ditchford",
    title: "Ditchford Bridge Restoration",
    type: "Heritage Structural Restoration",
    category: "Restoration",
    year: "2021",
    location: "Ditchford, Northamptonshire",
    client: "Northamptonshire Highways",
    cover: A.team,
    gallery: [A.team, A.sparks, A.aerial],
    overview: "Sensitive restoration of a historic Northamptonshire bridge, balancing preservation with structural longevity.",
    challenge: "Preserving the historic stonework while delivering modern structural standards to a heavily weathered bridge.",
    solution: "Hand-finished masonry restoration combined with hidden steel reinforcement and modern waterproofing.",
    outcome: "Heritage character preserved with a structural service life extended by 80+ years.",
    facts: ["Heritage restoration", "Masonry hand-finishing", "Hidden steel reinforcement", "+80 year life extension"]
  }
];

// Featured (for homepage), same 3 detailed projects, uniform size
export const featuredProjects = projects.slice(0, 3).map((p) => ({
  id: p.id,
  title: p.title.replace(" Replacement", "").replace(" Plastic Footbridge", " Footbridge"),
  subtitle: p.type,
  category: p.category,
  year: p.year,
  image: p.cover,
  description: p.overview.split(". ")[0] + "."
}));

export const services = [
  {
    id: 1,
    icon: "HardHat",
    title: "Public & Civil Engineering",
    description: "Civil engineering contractors in Birmingham since 1957. We build bridges, undertake structural repairs and deliver complex steelworks and fabrications across the UK.",
    bullets: ["Bridge construction", "Structural repairs", "Steelworks & fabrication", "Highways & rail"]
  },
  {
    id: 2,
    icon: "Users",
    title: "Our Clients",
    description: "Contracts ranging from £500 to £8,000,000, delivered with rigorous health & safety, full compliance and seamless integration with local authorities and private sector teams.",
    bullets: ["Local authorities", "Rail operators", "National contractors", "Private sector"]
  },
  {
    id: 3,
    icon: "Briefcase",
    title: "View Our Work",
    description: "Decades of award-winning delivery. Explore landmark bridges, complex steelworks and infrastructure renewal projects across the Midlands and beyond.",
    bullets: ["60+ years of projects", "ICE Award winners", "Heritage specialists", "24/7 emergency response"]
  }
];

export const stats = [
  { value: 1957, label: "Founded", suffix: "" },
  { value: 60, label: "Years of Heritage", suffix: "+" },
  { value: 8, label: "Million £ Largest Contract", suffix: "M" },
  { value: 1, label: "ICE Innovation Award", suffix: "x" }
];

export const milestones = [
  { year: "1957", title: "Founded", text: "R&C established as civil engineering contractors in Birmingham." },
  { year: "1983", title: "Spaghetti Junction Depot", text: "Based at our iconic depot beneath Spaghetti Junction." },
  { year: "1990", title: "Named 'Spaghetti Junction'", text: "Officially renamed our depot 'Spaghetti Junction', a local landmark." },
  { year: "2012", title: "ICE Award Winners", text: "Awarded the prestigious ICE Innovation of the Year." },
  { year: "2023", title: "FRP Innovation", text: "Delivered a 120-year sustainable footbridge made from 26,000 recycled plastic bottles." }
];

export const gallery = [
  A.aerial, A.sparks, A.team, A.garden, A.highway, A.braunstone, A.droitwich, A.cressbrook
];

export const associations = [
  { name: "BHSEA", sub: "Member" },
  { name: "CECA", sub: "Civil Engineering" },
  { name: "FTA", sub: "Member" },
  { name: "Greener Highways", sub: "Partner" }
];

export const clients = [
  { name: "Amey" }, { name: "Atkins" }, { name: "Avove" }, { name: "Balfour Beatty" },
  { name: "BBV" }, { name: "Birmingham City Council" }, { name: "Colas" }, { name: "Coventry City Council" },
  { name: "CRL" }, { name: "Dudley MBC" }, { name: "Egis" }, { name: "Kier" },
  { name: "Leicester City Council" }, { name: "Malvern & Wychavon" }, { name: "Milestone Infrastructure" },
  { name: "PJT Pumping" }, { name: "Ringway" }, { name: "Ringway Jacobs" }, { name: "Sandwell Council" },
  { name: "Serco" }, { name: "Shropshire Council" }, { name: "Smurfit Kappa" }, { name: "Tarmac" },
  { name: "VolkerFitzpatrick" }, { name: "VolkerLaser" }, { name: "Warwickshire Council" },
  { name: "Winvic" }, { name: "WJ Group" }, { name: "Wolverhampton Council" }, { name: "Worcestershire Council" }
];

// Team & values for About page
export const values = [
  { icon: "ShieldCheck", title: "Safety First", text: "Every site, every shift. Health & safety is the foundation of every R&C job." },
  { icon: "Hammer", title: "Craft & Quality", text: "Three generations of craftsmen who take pride in every weld, every pour, every finish." },
  { icon: "Handshake", title: "Trusted Partner", text: "Long-standing relationships with authorities, rail and national contractors built on results." },
  { icon: "Leaf", title: "Sustainable Build", text: "From FRP bridges to greener highways, engineering Britain responsibly." }
];

export const team = [
  { name: "Nigel Drew", role: "Chairman", group: "Leadership", image: "/team/nigel-drew.jpg", email: "nigel.drew@randcwilliams.ltd.uk", bio: "Steering R&C with six decades of civil engineering heritage at the helm." },
  { name: "Duncan Braybrooke", role: "Managing Director", group: "Leadership", image: "/team/duncan-braybrooke.jpg", bio: "Driving day-to-day delivery and the long-term strategy of the business." },
  { name: "Sam Drew", role: "Business Director", group: "Leadership", image: "/team/sam-drew.jpg", email: "sam.drew@randcwilliams.ltd.uk", bio: "Leading business development and partnerships across the public and private sector." },
  { name: "Richard Farrand", role: "Purchasing Manager", group: "Operations", image: "/team/richard-farrand.jpg", bio: "Sourcing the right materials, plant and supply chain for every R&C project." },
  { name: "Dale Tiller", role: "Contracts Manager", group: "Contracts", image: "/team/dale-tiller.jpg", email: "dale.tiller@randcwilliams.ltd.uk", bio: "Running multi-disciplinary civil engineering schemes from tender to handover." },
  { name: "Peter Gutteridge", role: "Contracts Manager", group: "Contracts", image: "/team/peter-gutteridge.jpg", email: "peter.gutteridge@randcwilliams.ltd.uk", bio: "Senior contracts oversight on bridges, structures and highways works." },
  { name: "Matt Cain", role: "Contracts Manager", group: "Contracts", image: "/team/matt-cain.jpg", email: "matt.cain@randcwilliams.ltd.uk", bio: "Hands-on delivery lead with deep heritage and infrastructure experience." },
  { name: "Dale Kovacs", role: "Contracts Co-Ordinator", group: "Contracts", image: "/team/dale-kovacs.jpg", email: "dalek@randcwilliams.ltd.uk", bio: "Keeping projects, paperwork and people moving in lockstep across every site." },
  { name: "Pym Westrik", role: "Quantity Surveyor", group: "Commercial", image: "/team/pym-westrik.jpg", bio: "Commercial guardian, costs, valuations and final accounts done properly." },
  { name: "Tony Evans", role: "Contracts Manager", group: "Contracts", image: "/team/tony-evans.jpg", email: "tony.evans@randcwilliams.ltd.uk", bio: "Senior contracts manager focused on safe, on-programme delivery." },
  { name: "Richard Toy", role: "Transport Manager", group: "Operations", image: "/team/richard-toy.jpg", email: "richard.toy@randcwilliams.ltd.uk", bio: "Owning the logistics that keep our depot, plant and crews on the move." },
  { name: "Alex Colesby", role: "Compliance Manager", group: "Compliance", image: "/team/alex-colesby.jpg", email: "alex@randcwilliams.ltd.uk", bio: "Standards, accreditations and quality systems across the business." },
  { name: "Arron Roberts", role: "Health & Safety Manager", group: "Compliance", image: "/team/arron-roberts.jpg", email: "arron.roberts@randcwilliams.ltd.uk", bio: "Every site, every shift, making sure everyone goes home safely." },
  { name: "Laura Toy", role: "Operations Assistant", group: "Office", image: "/team/laura-toy.jpg", email: "laura.toy@randcwilliams.ltd.uk", bio: "The systems and processes that keep the office running smoothly." },
  { name: "Aileen Bicknell", role: "Office Manager", group: "Office", image: "/team/aileen-bicknell.jpg", bio: "The heart of the office, coordinating people, paperwork and projects." },
  { name: "Lesley Martin", role: "Sales Ledger Clerk", group: "Office", image: "/team/lesley-martin.jpg", bio: "Keeping invoices, accounts and cashflow on track." },
  { name: "Sam Williams", role: "Company Accountant", group: "Office", image: "/team/sam-williams.jpg", bio: "Owning the books and the financial health of the business." },
  { name: "Curtis Farrand", role: "Yard & Plant Supervisor", group: "Operations", image: "/team/curtis-farrand.jpg", email: "curtis.farrand@randcwilliams.ltd.uk", bio: "Running the Spaghetti Junction depot and keeping plant ready for the job." },
  { name: "Qaiser Khan", role: "Senior Quantity Surveyor", group: "Commercial", email: "qaiser.khan@randcwilliams.ltd.uk", bio: "Senior commercial lead, measurement, valuations and cost control across major schemes." },
  { name: "Brad Gutteridge", role: "Site Manager", group: "Contracts", email: "brad.gutteridge@randcwilliams.ltd.uk", bio: "Running sites day to day, safe, tidy and on programme." },
  { name: "Fletcher Cooksey", role: "Apprentice Engineer", group: "Contracts", email: "fletcher.cooksey@randcwilliams.ltd.uk", bio: "The next generation of R&C engineering, learning the craft on live schemes." }
];

export const awards = [
  { year: "2012", title: "ICE Innovation of the Year", body: "Institution of Civil Engineers" },
  { year: "2023", title: "Sustainable Infrastructure Project", body: "Cressbrook Mill FRP Footbridge" },
  { year: "Member", title: "CECA", body: "Civil Engineering Contractors Association" },
  { year: "Member", title: "BHSEA", body: "Birmingham & West Midlands Health & Safety Association" }
];

// News / Blog
export const news = [
  {
    id: "three-peaks-challenge",
    title: "Three Peaks, 24 Hours: R&C Takes On the Mountains for Mates in Mind",
    excerpt: "Ben Nevis, Scafell Pike and Snowdon in a single 24-hour push, with the £2,000 fundraising target for Mates in Mind already smashed and £3,000 in sight.",
    date: "2026-06-13",
    category: "Community",
    cover: "https://customer-assets-39nsmqrw.emergentagent.net/job_polished-video-hero/artifacts/vw2tfn9u_3%20peaks%202.png",
    readTime: "3 min",
    body: [
      "The wait is over, the National Three Peaks Challenge is on. The R&C team arrived in Scotland and made their way to the foot of Ben Nevis, where the 24-hour countdown began at 17:00: the highest peaks in Scotland, England and Wales, back to back.",
      "Months of training, preparation and teamwork all came down to this. The team summited Snowdon in driving rain with the R&C flags flying, tired legs, big smiles, and a challenge completed together.",
      "Best of all: the £2,000 fundraising target for Mates in Mind, the charity tackling mental health across construction, was passed before the challenge even began, and the team is now pushing towards £3,000. A massive thank you to our sponsors and everyone who has backed the challenge. Be a mate. Be the change."
    ]
  },
  {
    id: "cressbrook-handover",
    title: "26,000 Plastic Bottles, One Footbridge: Cressbrook Mill Handover",
    excerpt: "Our Peak District FRP footbridge is officially open, reconnecting the Monsal Trail with a 120-year sustainable crossing.",
    date: "2024-04-12",
    category: "Project Complete",
    cover: assets.cressbrook,
    readTime: "4 min",
    body: [
      "After months of careful planning, R&C successfully installed the Cressbrook Mill FRP Footbridge in the heart of the Peak District National Park.",
      "Built using approximately 26,000 recycled plastic bottles, the bridge replaces a corroded predecessor with a structure designed to last 120 years with minimal maintenance.",
      "The lift itself was the highlight of the project, a single-day specialist crane operation through some of the narrowest access routes in the Peaks. Walkers between the Monsal Trail and Cressbrook Dale now enjoy uninterrupted, sustainable access for generations to come."
    ]
  },
  {
    id: "droitwich-corridor-phase-2",
    title: "Droitwich Health Corridor, Phase 2 Delivered",
    excerpt: "Safer, kinder streets for Droitwich: new footways, kerbing and drainage delivered on programme.",
    date: "2024-02-28",
    category: "Highways",
    cover: assets.droitwich,
    readTime: "3 min",
    body: [
      "R&C has completed Phase 2 of the Droitwich Health Corridor scheme on behalf of Worcestershire County Council.",
      "Phased works enabled the town's residents and businesses to keep moving while we delivered new footways, kerbing, drainage and surfacing, connecting healthcare and residential neighbourhoods with safer active-travel routes.",
      "We're proud to support healthier travel choices in the Midlands."
    ]
  },
  {
    id: "braunstone-flood-fix",
    title: "Braunstone Flood Fix: Failing Culvert Replaced",
    excerpt: "A new precast concrete box culvert is in. Better drainage, fewer floods, and a happier Mossdale Meadows.",
    date: "2024-01-18",
    category: "Drainage",
    cover: assets.braunstone,
    readTime: "3 min",
    body: [
      "R&C has completed the Braunstone Culvert Replacement at Mossdale Meadows, Leicester, improving drainage capacity and reducing future flood risk for the community.",
      "Restricted access, poor ground and an active watercourse made for a complex job, but our team delivered the new precast concrete box culvert safely, sustainably and on time."
    ]
  },
  {
    id: "60-year-anniversary",
    title: "60 Years Strong, A Note From the Team",
    excerpt: "Three generations, one mission: build the structures Britain relies on.",
    date: "2023-09-01",
    category: "Heritage",
    cover: assets.team,
    readTime: "5 min",
    body: [
      "From a small Birmingham contractor in 1957 to award-winning civil engineers today, six decades of work is something we don't take for granted.",
      "Our depot at Spaghetti Junction is now home to a team that spans three generations of craftsmen, engineers and project leaders. We're proud of where we've come from, and we're more excited than ever about what's next."
    ]
  }
];

export const caseStudies = [
  {
    client: "Leicester City Council",
    project: "Braunstone Culvert Replacement",
    quote: "R&C delivered a complex active watercourse replacement with professionalism, safety and care for the environment.",
    person: "Project Officer",
    cover: assets.braunstone
  },
  {
    client: "Worcestershire County Council",
    project: "Droitwich Health Corridor",
    quote: "A phased delivery that respected our residents and businesses, a true partner on a sensitive urban scheme.",
    person: "Highways Lead",
    cover: assets.droitwich
  },
  {
    client: "Derbyshire County Council",
    project: "Cressbrook Mill FRP Footbridge",
    quote: "Innovation with respect to the Peaks. 26,000 bottles, one beautiful sustainable bridge.",
    person: "Bridge Engineer",
    cover: assets.cressbrook
  }
];
